export const REDUCER_NAME = 'languages';
